import { useEffect, useRef } from "react";
import {
  setPreviewRole,
  usePreviewRole,
} from "../hooks/previewRoleStore";

export function PreviewBanner() {
  const role = usePreviewRole();
  const ref = useRef<HTMLDivElement | null>(null);

  // Give the banner its own row: publish its height as --preview-offset so
  // the fixed header, tab nav and page padding shift down under it (they'd
  // otherwise sit at top: 0 and be covered — the hamburger became
  // unclickable). ResizeObserver handles the text wrapping to two lines on
  // narrow screens.
  useEffect(() => {
    if (!role) return;
    const el = ref.current;
    if (!el) return;
    const apply = () =>
      document.documentElement.style.setProperty(
        "--preview-offset",
        `${el.offsetHeight}px`,
      );
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => {
      ro.disconnect();
      document.documentElement.style.setProperty("--preview-offset", "0px");
    };
  }, [role]);

  if (!role) return null;

  return (
    <div
      ref={ref}
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 15,
        background: "var(--c-yellow)",
        color: "var(--c-text)",
        borderBottom: "1px solid #e6c400",
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        fontSize: "0.9rem",
        fontWeight: 600,
        flexWrap: "wrap",
      }}
    >
      <span>
        Previewing as <strong>{role}</strong> — the rest of the site is
        rendered with {role}-level permissions.
      </span>
      <button
        type="button"
        onClick={() => setPreviewRole(null)}
        style={{
          background: "var(--c-text)",
          color: "var(--c-yellow)",
          padding: "6px 14px",
          minHeight: 32,
          fontSize: "0.85rem",
          borderRadius: "var(--r-pill)",
          border: "1px solid var(--c-text)",
        }}
      >
        Exit preview
      </button>
    </div>
  );
}
